import { NumberInput } from '@mantine/core';
import { CurrencySelected } from '../Shares/CurrencySelected';
import classes from './Wallet.module.css';
export const SelectCurrencyMenu: React.FC = () => {
  return <NumberInput size="md" flex={1} w="100%" prefix="$" value={7000} thousandSeparator="," decimalSeparator="." decimalScale={9} rightSectionWidth={100} classNames={{
    input: classes.input
  }} style={{
    zIndex: 300
  }} rightSection={<CurrencySelected />} readOnly />;
};